import {
  VAT_CALCULATION_MODE_OPTIONS,
  VatCalculationMode
} from "../constants/companyVatConstants";

export const formatVatPercentageDisplay = (
  vatPercentage?: number | null
): string | undefined => {
  if (vatPercentage == null || Number.isNaN(vatPercentage)) {
    return undefined;
  }
  return `${vatPercentage}%`;
};

export const formatVatCalculationModeDisplay = (
  mode: VatCalculationMode | undefined,
  t: (key: string, fallback: string) => string
): string | undefined => {
  if (!mode) {
    return undefined;
  }
  const option = VAT_CALCULATION_MODE_OPTIONS.find(
    (item) => item.value === mode
  );
  return option ? t(option.labelKey, option.defaultLabel) : mode;
};
